<template>
    <customer-layout>
        <div class="relative min-h-screen px-4 py-4 bg-gray-100">
            <div class="flex items-center justify-between">
                <h2 class="text-4xl font-bold text-pink-500">Orders</h2>
                <a v-if="user.is_admin == 1 || user.user_download !== null" :href="`/pdf/${user.id}`">
                    <div class="p-3 bg-white border border-gray-200 cursor-pointer">
                        download pdf
                    </div>
                </a>
            </div>
            <div class="mb-4" v-if="user.user_order.length > 0">
                <div v-for="(category, index) in purchased" :key="category.id" class="mt-6 mb-16 md:max-w-screen-xl">
                    <div v-if="category.length > 0">
                        <h2 class="text-2xl font-semibold capitalize">{{ index }}</h2>
                        <div class="grid grid-cols-1 gap-8 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                            <div v-for="product in category" :key="product.id" >
                                <div class="bg-white border border-gray-200 rounded-lg">
                                    <div>
                                        <img class="rounded-t-lg" :src="`${product.cover_photo_url}`" alt="">
                                    </div>
                                    <div class="flex flex-col justify-between p-4 cust_height">
                                        <h2 class="text-lg font-semibold">{{ product.title }}</h2>
                                        <p class="font-light">{{ product.description ? product.description.substr(0, 300) : ""}}</p>
                                        <p class="font-light">{{ product.description.substr(301) ? "...." : "" }}</p>
                                    </div>
                                    <div v-if="index === 'audiobook'" class="my-2 text-center cursor-pointer">
                                        <a :href="`/audiobook/${product.id}`">
                                            <button class="px-3 py-1 text-sm font-semibold text-white bg-pink-500 rounded-md">{{ $t('ascolta') }}</button>
                                        </a>
                                    </div>
                                    <div v-if="index === 'ebook'" class="my-2 text-center cursor-pointer">
                                        <a :href="`/img/ebooks/pdf/${product.pdf_url}`" target="_blank">
                                            <button class="px-3 py-1 text-sm font-semibold text-white bg-pink-500 rounded-md">{{ $t('download') }}</button>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="top-0 flex flex-col items-center justify-center w-full h-full min-h-screen mb-4 -mt-14">
                <span class="text-5xl">🙁</span>
                <span class="text-sm">No Order found. <a href="shop" class="underline">Let's order some items.</a></span>
            </div>
        </div>
    </customer-layout>
</template>
<script>
    import CustomerLayout from '../../Layouts/CustomerLayout.vue'

    export default {
        props: ['user', 'current', 'diamonds', 'purchased'],
        components: {
            CustomerLayout
        },
    }
</script>
<style scoped>
    .cust_height {
        min-height: 15rem;
    }
</style>